import React, { useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/ProductPage.css';


// ReactDOM.render(<ZoomImage />, document.getElementById('root'));

const ProductPage = () => {
  const { state } = useLocation();
  const product = state?.product || {}; // Use fallback empty object

  const [selectedPackSize, setSelectedPackSize] = useState('Ream - 500 sheets');
  const [quantity, setQuantity] = useState(1);
  
  const containerRef = useRef(null);
  const imageRef = useRef(null);

  const handlePackSizeChange = (size) => {
    setSelectedPackSize(size);
  };

  const handleQuantityChange = (increment) => {
    setQuantity((prev) => Math.max(1, prev + increment));
  };

  const handleMouseMove = (event) => {
    const container = containerRef.current;
    const image = imageRef.current;

        if (container && image) {
            const rect = container.getBoundingClientRect();
            const xPercent = ((event.clientX - rect.left) / rect.width) * 100;
            const yPercent = ((event.clientY - rect.top) / rect.height) * 100;

            image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
            image.style.transform = 'scale(1.5)'; // Adjust zoom level
        }
    };

    const handleMouseLeave = () => {
        const image = imageRef.current;
        if (image) {
            image.style.transform = 'scale(1)';
            image.style.transformOrigin = 'center';
        }
    };

  return (
    <div className="product-page">
      <div className="product-details">
        <div  className="zoom-container"
            ref={containerRef}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}>
          <img src={product.image} alt={product.name} className="zoom-image"
                ref={imageRef}/>
        </div>
        {/* <script src = 'zoomEffect.js'> </script> */}
        <div className="product-info">
          <h1>{product.name}</h1>
          <p className="product-description">{product.description}</p>
          <p className="product-price">{product.price}</p>

          <div className="pack-size">
            <h3>Paper Pack Size</h3>
            <button
              className={selectedPackSize === 'Ream - 500 sheets' ? 'selected' : ''}
              onClick={() => handlePackSizeChange('Ream - 500 sheets')}
            >
              Ream - 500 sheets
            </button>
            <button
              className={selectedPackSize === 'Case - 5000 sheets' ? 'selected' : ''}
              onClick={() => handlePackSizeChange('Case - 5000 sheets')}
            >
              Case - 5000 sheets
            </button>
          </div>

          <div className="quantity-selector">
            <h3>Quantity</h3>
            <button onClick={() => handleQuantityChange(-1)} disabled={quantity <= 1}>-</button>
            <span>{quantity}</span>
            <button onClick={() => handleQuantityChange(1)}>+</button>
          </div>

          <button className="add-to-cart-btn">ADD TO CART</button>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
